




import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class TextFieldCurrency extends VueExtendedBaseComponent {
  @Prop({default: 0})
  private index!: number

  @Prop()
  private value!: number

  @Prop({default: false})
  private readonly!: boolean

  @Prop({ default: false})
  private disabled!: boolean

  @Prop()
  private title!: string

  @Prop({default: true})
  private msgErr: string | boolean

  private position = 0

  get amountCurrency() {
    if (this.value) {
      return this.numeral(this.value)
    } else {
      return ''
    }
  }

  set amountCurrency(newValue: string) {
    const document = window.document
    const el = document.getElementById('currency' + this.index) as HTMLInputElement
    if (el) {
      const cursorPos = el.selectionEnd || 0
      let leftCursor = newValue.substring(0, cursorPos)
      const prefixLeft = leftCursor === '-' ? '-' : ''
      leftCursor = prefixLeft + this.numeral(leftCursor, '0[.][00]')
      const rightCursor = this.numeral(newValue.substring(cursorPos), '[0][.][00]')
      const concatValue = leftCursor + (parseFloat(rightCursor) > 0 ? this.removePrefix(rightCursor, '0') : '')
      const incPosition = Math.floor((this.numeral(concatValue.replace(/[-]/g, ''), '0').length - 1) / 3)
      this.position = leftCursor.length + incPosition
      newValue = this.numeral(concatValue)
      this.$emit('input', parseFloat(newValue.replace(/[,]/g, '') || '0'))
    }
  }

  private updated() {
    const el = document.getElementById('currency' + this.index) as HTMLInputElement
    if (el) {
      el.setSelectionRange(this.position, this.position)
    }
  }

  // get initialBalanceFormatted() {
  //   console.log(this.title || 'amount', this.value, typeof this.value)
  //   return this.value
  // }

  // set initialBalanceFormatted(newValue: any) {
  //   if (!this.disabled) {
  //     this.$emit('input', parseFloat(newValue.replace(/[,]/g, '') || 0))
  //   }
  // }
}
